/**
 * @description 数据字典 dataDictionary
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const dataDictionaryBiz = new Logic()

dataDictionaryBiz.deleteDic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.deleteDic,
    data: data
  })
}

dataDictionaryBiz.deleteTable = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.deleteTable,
    data: data
  })
}

dataDictionaryBiz.deleteTableProperty = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.deleteTableProperty,
    data: data
  })
}

dataDictionaryBiz.getDic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.getDic,
    data: data
  })
}

dataDictionaryBiz.getTable = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.getTable,
    data: data
  })
}

dataDictionaryBiz.getTableProperty = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.getTableProperty,
    data: data
  })
}

dataDictionaryBiz.getName = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.getName,
    data: data
  })
}

dataDictionaryBiz.getTableName = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.getTableName,
    data: data
  })
}

dataDictionaryBiz.saveDic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.saveDic,
    data: data
  })
}

dataDictionaryBiz.saveTable = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.saveTable,
    data: data
  })
}

dataDictionaryBiz.saveTableProperty = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.saveTableProperty,
    data: data
  })
}

dataDictionaryBiz.updateDic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.updateDic,
    data: data
  })
}

dataDictionaryBiz.updateProperty = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.updateProperty,
    data: data
  })
}

dataDictionaryBiz.updateTable = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.updateTable,
    data: data
  })
}

dataDictionaryBiz.connectDic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dataDictionary.connectDic,
    data: data
  })
}

export default dataDictionaryBiz
